import React, { useState, useEffect, useRef, useMemo } from 'react'
import { readAttachmentList } from "../helper/attachmentList.js";
import { logo } from '../assets/svg/svg';
import { getHostContract, getHostHelperContract } from '../helper/contract-helper';
import Cookies from "universal-cookie";
import { permanentlyDeleteEmail, updateEmailAttributeValue } from "../helper/emailHelper.js"
import { markMessageAsImportant } from '../helper/web3helper';
import { useDispatch, useSelector } from 'react-redux';
import { CompleteLoader, ReplyModal } from '../modals/common-alert';
import ContextMenu from './context/ContextMenu';
import { convertToLocalDate, getFirstLetterUppercase, convertToLocalDateforWeb2 } from '../helper/object-validation-helper';
import { deleteEmails } from '../helper/emailHelper.js';
import { updateInsecureMail, getEncryptedMessage } from '../service/api-actions.js';
import { getCachedMail, syncIndexedDB } from '../db/indexed-helper.js';
import { getSessionDEK, stripNul, symDecrypt } from '../helper/dekManager.js';
import { ENVELOPE_VERSION_V3, normalizeVersion, openV3 } from '../helper/envelopeV3.js';
import { Tooltip } from 'antd';
import Swal from 'sweetalert2'
import { toast, Bounce } from 'react-toastify';
import NoMessage from './NoMessage';
import { calender_svg } from "../assets/svg/calender_svg.js";
import { getGeneralSettings } from '../helper/settingsHelper.js';
import db from '../db/db-service.js';
import { isDecryptedValidData } from '../helper/decryptedDataValidate.js';
import { multipleDecryption } from '../helper/attachmentHelper.js';
import { Archive } from 'lucide-react';
import { reportError, toErrorString } from '../utils/errorLogger.js';
import { notifyChainFailure } from '../utils/txFeedback.js';
import { flattenMessages } from '../helper/messageListHelper.js';
import { CreateFolderModal } from '../modals/common-alert.js';
const cookies = new Cookies();

/** Shallow array compare, so an effect can bail instead of storing a fresh array with equal contents. */
const sameIds = (a = [], b = []) => a.length === b.length && a.every((value, i) => value === b[i]);

const Messages = (props) => {
    const [user] = useState(cookies.get("userObject"));
    const [messageList, setMessageList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [text, setText] = useState("Please wait for while your data is loading from the blockchain.")
    const [folderList, setFolderList] = useState([]);
    const filteredMessage = useSelector((state) => state.selectedMessageList);
    const [contextMenuVisible, setContextMenuVisible] = useState(false); // State to manage context menu visibility
    const [contextMenuPosition, setContextMenuPosition] = useState({ x: 0, y: 0 }); // State to manage context menu position
    const [archiveContent, setArchiveContent] = useState(false); // State to manage context menu visibility
    const [selectedContext, setContext] = useState(false);
    const [hoveredMessageIndex, setHoveredMessageIndex] = useState(null);
    const [selectedMessage, setSelectedMessage] = useState(null);
    const [message, setMessage] = useState(null);
    const [replyModal, setReplyModal] = useState(false);
    const [modalType, setModalType] = useState(false);
    const [attachment, setAttachment] = useState([]);
    const [checkedCollection, setCheckedCollection] = useState([]);
    const isClickableStar = ["Important", "Inbox", "Insecure", "Archive", "Sent"].includes(props.pageType);
    const isDragable = ["Important", "Inbox", "Sent"].includes(props.pageType);
    // Pagination lives in redux ONLY, because two components slice the same render list: this list and the
    // toolbar (MessageBoxHeader.js, which builds the select-all id set and the bulk-action scope from
    // exactly this page). Each used to keep its own copy, and every reRender() unmounts this component —
    // the parent flips props.loader while it refetches (CommonMessage.js) — so the list came back at its
    // local default of 50 while the toolbar still read the user's 100 from the store. Select-all then
    // ticked 100 ids for a page showing 50, and Archive/Delete/Move acted on rows the user never saw.
    const currentPage = useSelector((state) => state.currentPage);
    const messagesPerPage = useSelector((state) => state.messagesPerPage);
    const [openChildIndex, setOpenChildIndex] = useState([]);
    const dispatch = useDispatch();
    const dragImageRef = useRef(null);
    const pagiClickRight = useSelector((state) => state.pagiClickRight);
    const pagiClickLeft = useSelector((state) => state.pagiClickLeft);
    const [checkbox, setCheckBox] = useState({})
    const [starred, setStarred] = useState()
    const [createFolderOpen, setCreateFolderOpen] = useState(false);
    // Compute paginated messages.
    //
    // useMemo, not a bare slice. A fresh array on every render fed the selection-sync effect below,
    // which called setCheckedCollection with a fresh array of its own, which re-rendered, which
    // rebuilt the slice... React's bailout compares with Object.is and never matched, so the list
    // spun continuously (silently, in a production build), re-dispatching READ_LIST each pass and
    // resetting transient state under every toolbar control. That is what "so many buttons not at
    // all working" actually felt like.
    const indexOfLastMessage = currentPage * messagesPerPage;
    const indexOfFirstMessage = indexOfLastMessage - messagesPerPage;
    const contentPopup = useRef()
    const currentMessages = useMemo(
        () => props.messageList.slice(indexOfFirstMessage, indexOfLastMessage),
        [props.messageList, indexOfFirstMessage, indexOfLastMessage]
    );
    const userName = localStorage.getItem('UserName');

    useEffect(() => {
        dispatch({ type: "CURRENT_PAGE", payload: 1 });
    }, [props.messageList])
    const totalPages = Math.ceil(messageList.length / messagesPerPage);
    const contextMenuRef = useRef(null);
    // Pagination Controls
    const handlePageChange = (pageNumber) => {
        if (totalPages < pageNumber || pageNumber < 1) return;
        dispatch({ type: "CURRENT_PAGE", payload: pageNumber });
    };

    useEffect(() => {
        setMessageList(props.messageList);
        fetchData();
    }, [props.messageList])
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (contextMenuRef.current && !contextMenuRef.current.contains(e.target)) {
                setArchiveContent(false); // Close context menu
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    useEffect(() => {
        setIncludeMessage();
        const dragImageElement = document.createElement('div');
        dragImageElement.className = 'drag-image';
        dragImageElement.innerText = 'move this conversation';
        document.body.appendChild(dragImageElement);
        dragImageRef.current = dragImageElement;

        return () => {
            document.body.removeChild(dragImageElement);
        };
    }, []);

    /** The messages on this page, group children included. */
    const visibleMessages = useMemo(() => flattenMessages(currentMessages), [currentMessages]);

    /** The whole list flattened, in reading order — the coordinate space the reader's pager uses. */
    const flatMessages = useMemo(() => flattenMessages(props.messageList), [props.messageList]);
    const flatIndexOf = (message) => {
        const index = flatMessages.findIndex(item => item?.id === message?.id);
        return index === -1 ? 0 : index;
    };

    // Sync local checkedCollection with global selectedMessageList for visible items.
    // The equality bail is load-bearing: without it this effect stores a new array every pass.
    useEffect(() => {
        const visibleIds = visibleMessages.map(item => item?.id).filter(id => id !== undefined && id !== null);
        const intersection = (filteredMessage || []).filter(id => visibleIds.includes(id));
        setCheckedCollection(prev => (sameIds(prev, intersection) ? prev : intersection));
    }, [filteredMessage, visibleMessages]);

    async function setIncludeMessage() {
        const settingsJson = await getGeneralSettings();
        const insecure = settingsJson.isIncludePrevious;
        dispatch({ type: "IS_INCLUDE_MESSAGE", payload: insecure });
    }

    async function fetchData() {
        try {
            const helperContract = getHostHelperContract();
            const folderRecords = await helperContract.methods.getFolders(user.name).call();
            setFolderList(folderRecords);
        } catch (err) {
            console.log(err);
        }

    }

    // `FILTER_TYPE` was never dispatched anywhere in the codebase, so `.sort-added` was unreachable
    // and this was a permanent constant dressed up as state.
    const parentClassName = "sort-inactive";
    const handleGlobalClick = (e) => {
        const popupWidth = 182;
        const popupHeight = 311;
        const gap = 0;

        let finalLeft = e.clientX;
        let finalTop = e.clientY;
        const rect = e.target.getBoundingClientRect()
        const sidebarWidth = 0;
        const sidebarPosition = 'right';
        const spaceBelow = window.innerHeight - rect.bottom;
        const spaceAbove = rect.top;
        if (sidebarPosition === 'right') {
            const sidebarLimit = window.innerWidth - sidebarWidth;
            if (finalLeft + popupWidth > sidebarLimit) {
                finalLeft = sidebarLimit - popupWidth - gap;
            }
        }

        finalLeft = Math.max(gap, Math.min(finalLeft, window.innerWidth - popupWidth - gap));
        if (spaceBelow >= popupHeight + gap) {
            finalTop = rect.bottom + gap;
        } else if (spaceAbove >= popupHeight + gap) {
            finalTop = rect.top - popupHeight - gap;
        } else {
            finalTop = rect.top;
        }

        finalTop = Math.max(gap, Math.min(finalTop, window.innerHeight - popupHeight - gap));

        setContextMenuPosition({
            x: `${finalLeft - 80}px`,
            y: `${finalTop}px`,
        });
    };

    const handleContextMenu = async (e, item) => {
        e.preventDefault();
        await fetchData();
        handleGlobalClick(e)
        if (props.pageType === 'Trash') {
            setContextMenuVisible(true);
            setContext(item);
        }
        if (props.pageType === 'Archive') {
            setContextMenuVisible(true);
            setContext(item);
        }
        if (!isDragable) return true;
        setContextMenuVisible(true);
        setContext(item);
    };


    // Close context menu
    const handleCloseContextMenu = () => {
        setContextMenuVisible(false);
    };


    const dragStart = (e, message, type) => {
        const dragImage = dragImageRef.current;
        if (dragImage) {
            e.dataTransfer.setDragImage(dragImage, 0, 0);
            e.dataTransfer.setData('message_id', message.id);
            e.dataTransfer.setData('message_type', type);
        }
    };

    async function decryptfile(decrypteddata) {
        const encyrptedData = []
        const obj = JSON.parse(decrypteddata);
        // Both shapes — a message sent from the phone writes `attachments` (plural), and reading
        // only this client's own key meant its files were never decrypted. See helper/attachmentList.
        const attachment = readAttachmentList(obj)
        if (attachment.length) {
            attachment.map(async (file) => {
                const key = Object.keys(file)[0];
                encyrptedData.push({ fileName: key, attachmentUrl: file[key] })
            });
            const files = await multipleDecryption(encyrptedData)
            if (files) {
                toast.success("Files decrypted sucessfully")
            }
        }
    }

    const handleArchive = async (value, message) => {
        const messageId = message?.id;

        if (!user?.name || !messageId) {
            console.error("Missing required data:", {
                user: user?.name,
                messageId,
            });
            return;
        }

        setLoader(true);

        try {
            const ok = await updateEmailAttributeValue(
                user.name,
                [messageId],
                [{ key: 'isArchive', value: (value).toString() }],
                'hostContract'
            );
            if (!ok) notifyChainFailure(value ? 'archive this email' : 'move this email to the inbox');
        } catch (err) {
            const errorStr = toErrorString(err || err.message);
            reportError({
                endpoint: '-',
                message: `FileName: Messages.js, Fun: handleArchive, ${String(err.message || 'Unhandled error')}`,
                error: errorStr,
                userName: userName || '',
            });
            console.error("Transaction failed:", err);
        }
        props.reRender();
        props.setSelectedMessageIndex(null);
        setLoader(false);
    };

    const handleweb2emails = async (id, value) => {
        setLoader(true);
        try {
            await updateInsecureMail("Web2emails", [id], value);
            props.reRender();
        } catch (error) {
            console.error("Error while updating email:", error);
        } finally {
            setLoader(false);
        }
    };



    const actionClick = async (message, type) => {

        if (props.pageType === "Draft") {
            return true;
        }

        setLoader(true);
        if (!message.decryptedMessage) {
            const cacheType = message.emailType === 'Senttrash' ? 'Senttrash' : props.pageType;
            const functionNames = {
                "Sent": "updateEmailAttributes",
                "Inbox": "updateEmailAttributes",
            }
            try {
                // Cache first. A message that has already been decrypted once is served straight from the
                // DEK-encrypted local cache: no body fetch, and — the point of all this — no wallet prompt.
                // Only a miss pays for the network round-trip and the decrypt.
                let decryptedMsg = await getCachedMail(message.id, cacheType, message);
                const cacheHit = !!decryptedMsg;
                if (!cacheHit) {
                    // Always null: the organization read that used to sit here could only ever assign
                    // null to a variable that was already null (it even compared primaryEmail against
                    // that same null), so it decided nothing — it just charged every message open a DEK
                    // resolve, a symDecrypt and a JSON.parse for a value that was discarded.
                    const userName = null;
                    const data = await getEncryptedMessage(message.encryptedMsg, userName);
                    const encryptedMsg = data.returnValue ? data?.returnValue?.encryptedData : message.encryptedMsg;
                    decryptedMsg = encryptedMsg;
                    // The version is nested under returnValue, matching how encryptedData is read on
                    // the line above. Testing data.version (top level) was always undefined, so the
                    // v2 branch never fired and a DEK-sealed body fell through to ncog_decrypt — an
                    // asymmetric unwrap against symmetric ciphertext, rendering as a silent empty body.
                    //
                    // This is the ONE dispatch point for the body format, and it happens BEFORE any wallet
                    // call. The wallet must never be left to work out which format it was handed: an
                    // asymmetric unwrap of a v3 blob panics the Go runtime instead of returning an error.
                    // Anything unrecognised — including absent — is v1, which is what web2/Gmail-origin mail
                    // and everything predating the DEK rollout arrives as.
                    const bodyVersion = normalizeVersion(data?.returnValue?.version);
                    if (user?.name && bodyVersion === 'v2') {
                        // v2 bodies are sealed with the dMail DEK: one wallet unwrap per session, then a local
                        // symmetric decrypt. ('v2' discriminates the ROW — the WASM itself is always given 'v1'.)
                        const plain = stripNul(await symDecrypt(await getSessionDEK(), encryptedMsg));
                        decryptedMsg = isDecryptedValidData(plain) ? plain : "{}";
                        await decryptfile(decryptedMsg);
                    } else if (user?.name && bodyVersion === ENVELOPE_VERSION_V3) {
                        // v3 = <2596-char wrapped content key><body sealed under that key>. ONLY the wrapped
                        // key goes to the wallet — 2596 chars instead of the whole body and, on mobile, the
                        // whole attachment set with it. The body is then opened locally.
                        const plain = await openV3(encryptedMsg);
                        decryptedMsg = isDecryptedValidData(plain) ? plain : "{}";
                        await decryptfile(decryptedMsg);
                    } else if (user?.name) {
                        // Legacy v1: the whole blob goes to the wallet. 'v1' is the CRYPTO version and is the
                        // only value the wallet accepts; data?.version was always undefined here, so this
                        // already sent "v1" — now it says so.
                        const response = await window.ncogProvider.request({ method: 'ncog_decrypt', params: { cypherText: encryptedMsg, version: "v1" } });
                        if (!response?.response) {
                            setLoader(false);
                            return false;
                        }
                        decryptedMsg = isDecryptedValidData(response?.response?.replace(/\u0000+/g, '')?.trim()) ? response?.response?.replace(/\u0000+/g, '')?.trim() : "{}";
                        await decryptfile(decryptedMsg)
                    }
                    // Write it back so this message never has to be decrypted again. Safe to persist:
                    // syncIndexedDB seals the row with the dMail DEK before it touches the disk.
                    await syncIndexedDB(message.id, decryptedMsg, cacheType, message);
                } else {
                    await decryptfile(decryptedMsg);
                }
                const obj = JSON.parse(decryptedMsg);

                const functionParams = [user.name, [message.id], [{ key: 'isRead', value: 'true' }]];
                if (
                    (props?.pageType === "Trash" && !message?.isRead && message?.emailType === "Senttrash") ||
                    (!message?.read && props?.pageType !== "Insecure")
                ) {
                    await updateEmailAttributeValue(...functionParams, 'hostContract');
                }

                if (props.pageType === "Insecure" && !message.isRead) {
                    await updateInsecureMail('isRead', [message.id], 1);
                }
                const files = readAttachmentList(obj);
                if (files.length) {
                    setAttachment(files);
                }
                setMessage(obj.message);
            } catch (e) {
                const userName = localStorage.getItem('UserName');
                const errorStr = toErrorString(e || e.message);
                reportError({
                    endpoint: '/getEncryptedMessage, /updateInsecureMail',
                    message: `FileName: Messages.js, Fun: actionClick, ${String(e.message || 'Unhandled error')}`,
                    error: errorStr,
                    userName: userName || '',
                });
                setLoader(false);
                return true;
            }
        } else {
            const files = readAttachmentList(message.decryptedMessage);
            if (files.length) {
                setAttachment(files);
            }
            setMessage(message.decryptedMessage.message)
        }
        setSelectedMessage(message);
        setLoader(false);
        setReplyModal(true);
        setModalType(type);


    }

    useEffect(() => {
        setAttachment([]);
    }, [replyModal])

    const fetchSenderReceiver = (message) => {
        if (props.pageType === "Sent") {
            try {
                if (!message.receiver || message.receiver === 'undefined') {
                    const emailDetailsStr = message.emailDetails || message.header;
                    if (emailDetailsStr) {
                        const emailDetails = typeof emailDetailsStr === 'string' 
                            ? JSON.parse(emailDetailsStr) 
                            : emailDetailsStr;
                        const to = emailDetails.to;
                        if (Array.isArray(to)) {
                            return to.join(', ');
                        } else if (typeof to === 'string') {
                            return to;
                        }
                    }
                    return '';
                }
                
                const receiverObj = JSON.parse(message.receiver);
                const to = receiverObj.to.join(', ');
                return `${to}`;
            } catch (error) {
                const errorStr = toErrorString(error || error.message);
                reportError({
                    endpoint: '-',
                    message: `FileName: Messages.js, Fun: fetchSenderReceiver, ${String(error.message || 'Unhandled error')}`,
                    error: errorStr,
                    userName: userName || '',
                });
                console.error("Error parsing receiver JSON:", error);
                return '';
            }
        } else {
            return message.sender.split("@")[0];
        }
    };

    const getFolderIndex = useSelector((state) => state.folderIndex);
    const deleteMessage = async (message, msgId, index) => {
        Swal.fire({
            text: "Are you sure you want to delete?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#1677ff",
            cancelButtonColor: "#7f7f7f",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            customClass: "compose-sweet-alert"
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoader(true);
                const folderIndex = getFolderIndex;
                const ok = await deleteEmails(message, msgId, index, messageList, props.pageType, folderIndex, true);
                props.reRender();
                props.setSelectedMessageIndex(null);
                setLoader(false);
                if (!ok) notifyChainFailure('delete this email');
            }
        });

    }
    const dragEnd = (e) => {
        // Reset cursor to default
        document.body.classList.remove('grabbing');
    };

    // Two effects are gone from here.
    //
    // The All / None / Read / Unread / Starred modes used to be applied in this component off a redux
    // value, so re-picking the mode you were already on changed nothing and the menu felt dead. The
    // toolbar now computes the ids and dispatches the selection itself; this component only mirrors
    // it (see the sync effect above).
    //
    // The other pushed a freshly-built READ_LIST array into the store on every pass. Nothing read
    // `state.readList` any more, and each dispatch re-rendered every useSelector subscriber — one of
    // the amplifiers of the render loop.

    // Must return a real boolean. Returning undefined for "not selected" made this a controlled/
    // uncontrolled flip-flop, and React's updateChecked skips the DOM write when checked == null —
    // so clearing the selection left every row still visually ticked, which reads exactly like a
    // broken select-all.
    const handleChecked = (message) => checkedCollection.includes(message.id);

    const selectMessage = (id) => {

        if (checkedCollection.includes(id)) {
            const list = checkedCollection.filter((item) => item !== id);
            setCheckedCollection(list);
            dispatch({ type: "SELECTED_MESSAGE_LIST", payload: list });
        } else {
            setCheckedCollection([...checkedCollection, id]);
            dispatch({ type: "SELECTED_MESSAGE_LIST", payload: [...checkedCollection, id] });
        }
    }

    const getPageNumbers = () => {
        const pageNumbers = [];
        const totalPagesToShow = 5;

        if (totalPages <= totalPagesToShow) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            const startPage = Math.max(1, currentPage - Math.floor(totalPagesToShow / 2));
            const endPage = Math.min(totalPages, startPage + totalPagesToShow - 1);

            if (startPage > 1) {
                pageNumbers.push(1);
                if (startPage > 2) pageNumbers.push('...');
            }

            for (let i = startPage; i <= endPage; i++) {
                pageNumbers.push(i);
            }

            if (endPage < totalPages) {
                if (endPage < totalPages - 1) pageNumbers.push('...');
                pageNumbers.push(totalPages);
            }
        }
        return pageNumbers;
    };

    const handleItemsPerPageChange = (event) => {
        dispatch({ type: "MESSAGE_PER_PAGE", payload: Number(event.target.value) });
        // Back to page 1 with it, or the user is stranded: page 7 of a 50-per-page list does not exist at
        // 100 per page, and a slice past the end renders an empty list with no rows and no way back.
        dispatch({ type: "CURRENT_PAGE", payload: 1 });
    };

    useEffect(() => {
        handlePageChange(currentPage + 1);
    }, [pagiClickRight])

    useEffect(() => {
        handlePageChange(currentPage - 1);
    }, [pagiClickLeft])
    useEffect(() => {
        handlePageChange(1);
    }, [])

    const reRender = () => {
        props.reRender();
    }

    const deleteLastThirty = () => {
        Swal.fire({
            text: "Are you sure you want to trash more than 30 days?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#1677ff",
            cancelButtonColor: "#7f7f7f",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            customClass: "compose-sweet-alert"
        }).then(async (result) => {
            if (result.isConfirmed) {
                const parseDate = (dateString) => new Date(dateString);
                const today = new Date();
                const thirtyDaysAgo = new Date(today);
                thirtyDaysAgo.setDate(today.getDate() - 30);
                const recentMessages = currentMessages.filter(message => {
                    const receivedDate = parseDate(message.receivedDate);
                    return receivedDate < thirtyDaysAgo;
                });
                if (!recentMessages.length) {
                    if (!toast.isActive("noDataFound")) {
                        toast.info("No data found!", {
                            toastId: "noDataFound",
                            position: "top-center",
                            transition: Bounce,
                        });
                    }
                    return;
                }
                setLoader(true);
                const ok = await deleteEmails(recentMessages, null, null, null, 'emptyTrash', null);
                setLoader(false);
                if (!ok) notifyChainFailure('empty the trash');
                props.reRender();
            }
        });
    }
    const handleDraftmail = async (id) => {
        try {
            Swal.fire({
                text: "Are you sure you want to delete draft?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#1677ff",
                cancelButtonColor: "#7f7f7f",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                customClass: "compose-sweet-alert"
            }).then(async (result) => {
                if (result.isConfirmed) {
                    setLoader(true);
                    await db.table('draft').delete(id);
                    props.reRender();
                }
            });

        } catch (err) {
            const errorStr = toErrorString(err || err.message);
            reportError({
                endpoint: '-',
                message: `FileName: Messages.js, Fun: handleDraftmail, ${String(err.message || 'Unhandled error')}`,
                error: errorStr,
                userName: userName || '',
            });
            console.error(err)
        }
        finally {
            props.reRender();
            setLoader(false);
        }
    }
    const chunkArray = (array, size) => {
        const result = [];
        for (let i = 0; i < array.length; i += size) {
            result.push(array.slice(i, i + size));
        }
        return result;
    };
    /** Returns false if any chunk's chain write failed to land. */
    async function deleteBulkEmails(inbox, __, value3, pagetype, getFolderIndex, functionName) {
        let ok = true;
        if (value3.length > 0) {
            const updatedResponse = [];
            value3.forEach((data) => {
                updatedResponse.push(data.messageId);
            });
            const chunks = chunkArray(updatedResponse, 25);
            for (const chunk of chunks) {
                let value = chunk;
                if (!await functionName(inbox, value, null, value3, pagetype, getFolderIndex)) ok = false;
            }
        }
        return ok;
    }
    async function web2EmailsDelete(Emails, batchSize, type, functionName, resValue) {
        if (Emails.length > 0) {
            const updatedResponse = [];
            Emails.forEach((data) => {
                updatedResponse.push({
                    id: data.messageId || data.id,
                    value: resValue,
                });
            });
            const chunks = chunkArray(updatedResponse, batchSize);
            for (const chunk of chunks) {
                let value = chunk;
                await functionName(type, "", value);
            }
        }
    }
    const emptyTrash = () => {
        const response = messageList.map(data => {
            if (data.groupKey) {
                return data.data;
            }
            else {
                return data;
            }
        }
        ).filter(Boolean).flat();
        const web3 = response.filter((data) => data.mailtype === "web3emails");
        const senttrash = response.filter((data) => data.emailType === "Senttrash");
        const web2 = response.filter((data) => data.mailtype === "web2emails");



        Swal.fire({
            text: "Are you sure you want to empty trash?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#1677ff",
            cancelButtonColor: "#7f7f7f",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            customClass: "compose-sweet-alert"
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoader(true);
                await deleteBulkEmails(senttrash, null, senttrash, "Trash", null, deleteEmails)
                if (web3.length > 0) {
                    const updatedResponse = [];
                    web3.forEach((data) => {
                        updatedResponse.push(data.messageId);
                    });
                    const chunks = chunkArray(updatedResponse, 25);
                    for (const chunk of chunks) {
                        await permanentlyDeleteEmail(user.name, chunk, 'hostContract');
                    }
                }
                await web2EmailsDelete(web2, 50, "bulkdelete", updateInsecureMail, 3)
                setLoader(false);
                props.reRender();
            }
        });
    }
    const Archivemessage = async (e, message) => {
        e.preventDefault();
        if (props.pageType === "Insecure") {
            setArchiveContent(true);
            setContext(message)
        }
    };

    const deleteweb2email = async (messageId) => {

        Swal.fire({
            text: "Are you sure you want to delete this email?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#1677ff",
            cancelButtonColor: "#7f7f7f",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            customClass: "compose-sweet-alert"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const value = 1;
                    setLoader(true);
                    await updateInsecureMail('deleteemail', messageId, value);
                }
                catch (err) {
                    const errorStr = toErrorString(err || err.message);
                    reportError({
                        endpoint: '/updateInsecureMail',
                        message: `FileName: Messages.js, Fun: deleteweb2email, ${String(err.message || 'Unhandled error')}`,
                        error: errorStr,
                        userName: userName || '',
                    });
                    console.log(err);
                }
                finally {
                    setLoader(false);
                    props.reRender();
                }
            }
        });

    }
    const permanentdelete = async (messageid) => {
        Swal.fire({
            text: "Are you sure you want to empty trash?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#1677ff",
            cancelButtonColor: "#7f7f7f",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            customClass: "compose-sweet-alert"
        }).then(async (result) => {
            if (result.isConfirmed) {
                const value = 3;
                setLoader(true);
                await updateInsecureMail('deleteemail', messageid, value);
                setLoader(false);
                props.reRender();
            }
        });

    }

    const handleSentMailTrash = async (messageId) => {
        Swal.fire({
            text: "Are you sure you want to delete this email?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#1677ff",
            cancelButtonColor: "#7f7f7f",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            customClass: "compose-sweet-alert"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {

                    setLoader(true);
                    await await deleteEmails(null, [messageId.id], null, [messageId], "Sent", null,)
                }
                catch (err) {
                    const errorStr = toErrorString(err || err.message);
                    reportError({
                        endpoint: '-',
                        message: `FileName: Messages.js, Fun: handleSentMailTrash, ${String(err.message || 'Unhandled error')}`,
                        error: errorStr,
                        userName: userName || '',
                    });
                    console.log(err);
                }
                finally {
                    setLoader(false);
                    props.reRender();
                }
            }
        });

    }


    const handleStart = (e, id) => {
        e.dataTransfer.setData('text', id);
    }
    const messageContents = (message, index) => {
        return (
            <div className="position-relative" onDragStart={(e) => { handleStart(e, message.id) }} key={index} >
                <div className={'row-message-box-child' + ` ${message.read || message.isRead ? "Readed" : "Unreaded"} ${parentClassName}`} draggable={isDragable ? 'true' : 'false'} onDragStart={(e) => dragStart(e, message, props.pageType)} onDragEnd={dragEnd} onContextMenu={(e) => {
                    handleContextMenu(e, message)
                    Archivemessage(e, message)
                }} onMouseEnter={() => setHoveredMessageIndex(message.id)} onMouseLeave={() => setHoveredMessageIndex(null)} key={index}
                    onClick={(e) => {

                        if (props.pageType === "Draft") {
                            const draftJSON = message;
                            localStorage.setItem("recipient", draftJSON.to);
                            localStorage.setItem("topic", draftJSON.subject);
                            localStorage.setItem("cc", draftJSON.cc)
                            localStorage.setItem("bcc", draftJSON.bcc);
                            localStorage.setItem("sendingEmail", draftJSON.message);
                            dispatch({ type: "DRAFT", payload: JSON.stringify(message) });
                            return true;
                        } else if (props.pageType === "Outbox") {
                            dispatch({ type: "OUTBOX", payload: index, value: true });
                            return true;
                        }

                        // The reader's Next/Previous walks the FLATTENED list, so it has to be handed a
                        // flattened index. It used to receive the index within the current page (and,
                        // for a conversation child, the index within its group), so on page 2 "Next"
                        // jumped back into page 1 and grouped rows were wrong everywhere.
                        props.setSelectedMessageIndex(flatIndexOf(message));
                        props.openMessage(message);

                        if (message.decryptedMessage) {
                            props.setIsDecrypted(true);
                            props.setDecryptedContent(JSON.stringify(message.decryptedMessage));
                        }
                    }}
                >
                    <div className='user-check-section' id='list-message-component'>
                        {/* stopPropagation lives on the wrapper so the row does not open the message.
                            The toggle itself is onChange, which is what React needs to keep the DOM
                            checkbox in step and what makes it reachable by keyboard. */}
                        <div className='check-box-ele-user' onClick={(e) => e.stopPropagation()}>
                            <input
                                type="checkbox"
                                aria-label="Select message"
                                checked={handleChecked(message)}
                                onChange={() => selectMessage(message.id)}
                            />
                        </div>
                        <div className={`check-box-ele-user ${isClickableStar ? 'clickable' : 'not-clickable'}`} onClick={async (e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            if (props.pageType === "Insecure") {
                                setLoader(true);
                                await updateInsecureMail('fav', [message.id], "");
                                setLoader(false);
                                props.reRender();
                                return;
                            } else if (props.pageType === "Important" || props.pageType === "Inbox") {
                                setLoader(true);
                                const contractMethods = getHostContract();
                                const obj = [parseInt(message.id)];
                                const value = message.isStarred;
                                const ok = await markMessageAsImportant(contractMethods, user.name, obj, value, user.wallet);
                                setLoader(false);
                                if (!ok) notifyChainFailure(value ? 'unstar this email' : 'star this email');
                                props.reRender();
                            }
                            else if (props.pageType === "Archive" || props.pageType === "Sent") {
                                if (message.mailtype === "Senttrash" || message.mailtype === "web3emails") {
                                    setLoader(true);
                                    const contractMethods = getHostContract();
                                    const obj = [parseInt(message.id)];
                                    const value = message.isStarred;
                                    const ok = await markMessageAsImportant(contractMethods, user.name, obj, value, user.wallet);
                                    setLoader(false);
                                    if (!ok) notifyChainFailure(value ? 'unstar this email' : 'star this email');
                                    props.reRender();
                                }
                                else if (message.mailtype === "web2emails") {
                                    setLoader(true);
                                    const contractMethods = getHostContract();
                                    const obj = [parseInt(message.id)];
                                    const value = message.isStarred;
                                    const ok = await markMessageAsImportant(contractMethods, user.name, obj, value, user.wallet);
                                    setLoader(false);
                                    if (!ok) notifyChainFailure(value ? 'unstar this email' : 'star this email');
                                    props.reRender();
                                }
                            }
                            setLoader(false);
                        }}>
                            {message.isStarred &&
                                <Tooltip title="Starred" placement='bottom'>  <div className='start-icon-div'> {logo.star_svg_fill}  </div></Tooltip>
                            }

                            {!message.isStarred &&
                                <Tooltip title="Not Starred" placement='bottom'>    <div className='start-icon-div' > {logo.star_svg_outline}  </div></Tooltip>
                            }
                        </div>
                        {/* <div className="ncog-seperation"> | </div> */}
                    </div>

                    <div className='user-details-section message-section'>
                        <div className='user-profile-pic'>{getFirstLetterUppercase(fetchSenderReceiver(message))} </div>
                        <div className='user-profile-name inbox mail-username'>
                            <div className='user-profile-username from-name'>{props.pageType === "Sent" ? "To: " : ""}{fetchSenderReceiver(message)}</div>
                            {props.pageType !== "Sent" &&
                                <div className='user-profile-useremail'>{message.sender}</div>
                            }
                        </div>
                        {/* <div className="ncog-seperation inbox-value"> | </div> */}
                    </div>

                    <div className={`user-subject-section ${message.read || message.isRead ? "Readed" : "Unreaded"}`}>
                        Topic : <span> {message.subject} </span>
                    </div>
                    <div className='user-encryption-section' onClick={(e) => {
                        e.stopPropagation();
                    }}>
                        <div className={`user-date-section ${hoveredMessageIndex === message.id ? 'hidden' : ''}`}>
                            {props.pageType === 'Insecure' ? convertToLocalDateforWeb2(message.date || message.created_at) : convertToLocalDate(message.date || message.created_at)}
                        </div>
                        {hoveredMessageIndex === message.id ?
                            <div className='hover-reply'>
                                {props.pageType !== "Draft" && props.pageType !== "Outbox" && props.pageType !== "Trash" &&
                                    <>
                                        {/* "ReplyAll", not "Reply": the composer (ReplyModal in modals/common-alert.js)
                                            only pre-fills CC/BCC and the other original recipients on the "ReplyAll"
                                            branch. Sending "Reply" from here made this button a plain reply — everyone
                                            but the sender was silently dropped off the thread. */}
                                        <Tooltip title="Reply all"><div onClick={() => { actionClick(message, "ReplyAll"); }} > {logo.back_arrow_reply} </div></Tooltip>
                                        <Tooltip title="Reply"><div onClick={() => { actionClick(message, "Reply"); }} >  {logo.default_back_reply} </div></Tooltip>
                                        <Tooltip title="Archive"><div onClick={() => {
                                            if (props.pageType === "Insecure") {
                                                handleweb2emails(message.messageId, "TRUE");
                                            } else {
                                                handleArchive(true, message);
                                            }
                                        }}><Archive className="text-white" width={18} height={15} /></div></Tooltip>
                                        <Tooltip title="Forward"><div onClick={() => { actionClick(message, "Forward"); }} > {logo.forward_reply_svg} </div></Tooltip>
                                    </>
                                }
                                <Tooltip title="Delete">
                                    {message.mailtype === "web3emails" ?
                                        <div onClick={() => {
                                            deleteMessage(message, message.id, index);
                                        }}> {logo.delete_reply_svg} </div> :
                                        props.pageType === "Trash" ? <div onClick={() => {
                                            permanentdelete(message.id);
                                        }}> {logo.delete_reply_svg} </div> :
                                            props.pageType === "Sent" ? <div onClick={() => {
                                                handleSentMailTrash(message);
                                            }}> {logo.delete_reply_svg} </div> :

                                                props.pageType === "Draft" ?
                                                    <div onClick={() => {
                                                        handleDraftmail(message.id);
                                                    }}> {logo.delete_reply_svg} </div> :
                                                    <div onClick={() => {

                                                        deleteweb2email(message.id);
                                                    }}> {logo.delete_reply_svg} </div>
                                    }
                                </Tooltip>
                            </div>
                            : (
                                <div >
                                    <div className='lock-logo'>
                                        {message.decryptedMessage && logo.key_unlock_svg}
                                        {!message.decryptedMessage && logo.key_lock_svg}
                                    </div>
                                </div>
                            )}
                    </div>
                </div >
            </div>
        )

    }
    const setChildIndex = (index) => {
        openChildIndex.includes(index) ? setOpenChildIndex(openChildIndex.filter(item => item !== index)) : setOpenChildIndex([...openChildIndex, index])
    }

    const checkReaded = (message) => {
        return message.data.every((item) => item.read);
    }
    // Deps were `[props]` — a new object on every parent render, so this recomputed constantly and
    // fed the render loop. It only ever depends on the page slice.
    useEffect(() => {
        setStarred(currentMessages.map((res) => (
            res?.groupKey && Array.isArray(res.data) ? res.data.map(item => item.isStarred === false) : null
        )));
    }, [currentMessages]);
    const handleCheckbox = (message) => {
        if (message?.groupKey && Array.isArray(message.data)) {
            const response = message.data.map(item => item.id);
            const allChecked = response.every(id => checkedCollection.includes(id));
            if (allChecked) {
                const updatedCollection = checkedCollection.filter(id => !response.includes(id));
                setCheckedCollection(updatedCollection);
                dispatch({ type: "SELECTED_MESSAGE_LIST", payload: updatedCollection });
            } else {
                const updatedCollection = [...checkedCollection, ...response.filter(id => !checkedCollection.includes(id))];
                setCheckedCollection(updatedCollection);
                dispatch({ type: "SELECTED_MESSAGE_LIST", payload: updatedCollection });
                setCheckBox((prevState) => ({
                    ...prevState,
                    [message.groupKey]: response.every(id => updatedCollection.includes(id)),
                }));
            }
        }
    };
    useEffect(() => {
        const initialGroupState = {};
        currentMessages?.forEach((message) => {
            if (message?.groupKey && Array.isArray(message.data)) {
                const response = message.data.map(item => item.id);
                const isAllGroupChecked = response.every(id => checkedCollection.includes(id));
                initialGroupState[message.groupKey] = isAllGroupChecked;
            }
        });
        setCheckBox(initialGroupState);
    }, [currentMessages, checkedCollection]);
    return (
        <div >
            {props.pageType === 'Trash' &&
                <div className="card trash-header">
                    <p className="card-header d-flex align-center justify-content-center title">Delete Messages that have been in <span className='gradient-text cursor-pointer' onClick={() => { deleteLastThirty() }}>&nbsp;Trash more than 30 days&nbsp;</span>  or <span className='gradient-text cursor-pointer' onClick={() => { emptyTrash() }}>&nbsp;Empty Trash now&nbsp;</span></p>
                </div>
            }
            {currentMessages.map((message, index) => (
                <React.Fragment key={`message_${index}`}>
                    <div className='d-flex'>
                        {currentMessages.some(item => item?.data?.length) && (
                            <div className='d-flex gap-1 mt-20px h-fit'>
                                {message?.data?.length ? (
                                    <div className='accordion-width w-40px d-flex align-items-center gap-1'>
                                        <span onClick={() => { setChildIndex(index) }} className={`rotate-icon cursor-pointer ${openChildIndex.includes(index) ? 'open' : 'close'}`}>{calender_svg.down_svg}</span>
                                        <span className="group-count">{message?.data?.length > 9 ? '9+' : message?.data?.length}</span>
                                    </div>
                                ) : (
                                    //set empty width
                                    <div className='w-40px'></div>
                                )
                                }
                            </div>
                        )}
                        {!message.groupKey ? (
                            <div key={index} className='w-100'>{messageContents(message, index)}
                            </div>
                        ) : (
                            <div key={index} className='w-100'>
                                <div className={`row-message-box-child user-select-none +  ${checkReaded(message) ? "Readed" : "Unreaded"}`} onClick={() => { setChildIndex(index) }}>
                                    <div className='user-check-section'>
                                        <div className='check-box-ele-user gap-10' onClick={(e) => e.stopPropagation()}>
                                            <input
                                                type="checkbox"
                                                aria-label="Select conversation"
                                                checked={!!checkbox[message.groupKey]}
                                                onChange={() => handleCheckbox(message)}
                                            />
                                            {starred && starred[index] && (
                                                <div className='start-icon-div' key={index}>
                                                    {starred[index].includes(false) ? logo.star_svg_fill : logo.star_svg_outline}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className='user-details-section message-section' >

                                        <div className="user-profile-pic">{getFirstLetterUppercase(message.groupKey.split('___')[0] ?? '#')}</div>
                                        <div className='user-profile-name inbox mail-username' >
                                            <div className='user-profile-username from-name'>{props.pageType === "Sent" ? `To: ${message.groupKey.split('___')[0] ?? ''}` : message.groupKey.split('___')[0].split('@')[0] ?? ''}{ }</div>
                                            {props.pageType !== "Sent" &&
                                                <div className='user-profile-useremail'>{message.groupKey.split('___')[0] ?? ''}</div>
                                            }
                                        </div>
                                    </div>
                                    <div className='user-subject-section group'>
                                        Topic : <span>{message.groupKey.split('___')[1] ?? ''}</span>
                                    </div>
                                    <div className='user-encryption-section'>
                                        <div className='user-date-section'>
                                            {props.pageType === 'Insecure' ? convertToLocalDateforWeb2(message.date) : convertToLocalDate(message.date)}
                                        </div>
                                    </div>
                                </div>

                                {openChildIndex.includes(index) &&
                                    <div className='group-emails'>
                                        {message.data.map((msg, ind) => {
                                            return <div className='w-100'>{messageContents(msg, ind, true)}</div>
                                        })}
                                    </div>
                                }
                            </div>
                        )}
                    </div>
                </React.Fragment >
            ))
            }

            {/* Hidden drag image */}
            <div ref={dragImageRef} className='d-none'>
                <div className="drag-image">move this conversation</div>
            </div>
            <CompleteLoader isOpen={loader} text={text} />
            {
                ((contextMenuVisible) || archiveContent) && (
                    <ContextMenu
                        x={contextMenuPosition.x}
                        y={contextMenuPosition.y}
                        onClose={handleCloseContextMenu}
                        types={folderList}
                        selectedContext={selectedContext}
                        loader={setLoader}
                        pageType={props.pageType}
                        reRender={reRender}
                        text={setText}
                        messageList={messageList}
                        actionClick={actionClick}
                        openCreateFolder={() => setCreateFolderOpen(true)}
                    />
                )
            }
            {/* Owned here, not by ContextMenu. Inside the menu the "Create Folder" click bubbled to the
                wrapper's onClose, which unmounted ContextMenu and destroyed the popup state before the
                modal could render — so the item did nothing at all. */}
            <CreateFolderModal isOpen={createFolderOpen} close={() => { setCreateFolderOpen(false); props.reRender(); }} />
            {
                currentMessages.length > 0 &&
                <div className="pagination-controls">
                    <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>{logo.left_arrow_svg}</button>
                    {getPageNumbers().map((page, index) => (

                        <button
                            key={index}
                            onClick={() => handlePageChange(page)}
                            className={page === currentPage ? 'active' : ''}
                            disabled={page === '...'}
                        >
                            {page}
                        </button>
                    ))}
                    <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>{logo.right_arrow_svg}</button>
                    <span>per page:</span>
                    <select className="items-per-page-select"
                        value={messagesPerPage}
                        onChange={handleItemsPerPageChange}
                    >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select>
                </div>
            }
            {
                !props.messageList &&
                < NoMessage pageType={props.pageType} />
            }
            <ReplyModal isModalOpen={replyModal} close={() => { setReplyModal(false); if (replyModal) { props.reRender() } }} attachmentValue={attachment} msg={selectedMessage} decryptedMessage={message} messageType={modalType} pageType={props.pageType} />
        </div >
    )
}

export default Messages
